exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list__tile__content[data-v-0d18cdfa]{overflow:inherit}", ""]);

// exports
